module.exports = __webpack_public_path__ + "static/img/logo.5366a656.png";